import { render, staticRenderFns } from "./loadingCustom.vue?vue&type=template&id=03f45ded"
import script from "./loadingCustom.vue?vue&type=script&lang=js"
export * from "./loadingCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports